module.exports = __webpack_public_path__ + "fonts/isZ-wbCXNKAbnjo6_TwHToX0hVgzZQUfRDuZrPvH3D8.woff2";